import { useContext, useState } from 'react';
import { FilterContext } from '../../../filterTools';
import { EstateType, FilterParams } from '~js/React/Enums';

const ExtraFilterBtn = ({
  setTabIndex,
  tabIndex,
  showExtraCriterias,
  setShowExtraCriterias,
}: {
  setShowExtraCriterias(val: boolean): void;
  setTabIndex(val: number): void;
  tabIndex: number;
  showExtraCriterias: boolean;
}): JSX.Element => {
  const [filterText, setFilterText] = useState<string>('Visa fler filter');
  const element = document.getElementById('extra-criterias');
  const arrow = document.getElementById('extra-criterias-arrow');
  const filterContext = useContext(FilterContext);
  const existingTag = filterContext.tags.find(
    (x) => x.type === FilterParams.ESTATETYPE_PARAM
  );

  function toggleExtraCriterias() {
    arrow?.classList.toggle('rotate-180');
    ['max-h-7xl'].map((x) => element?.classList.toggle(x));
    if (tabIndex !== 0) {
      setTabIndex(0);
    } else {
      setTabIndex(-1);
    }
    if (!showExtraCriterias) {
      setShowExtraCriterias(true);
      setFilterText('Dölj filter');
    } else {
      setShowExtraCriterias(false);
      setFilterText('Visa fler filter');
    }
  }
  return (
    <button
      className={`select-none px-8 mb-6 pb-1 mt-2 text-center text-blue700 mx-auto flex hover:cursor-pointer focus:outline-none button ${
        showExtraCriterias ? 'lg:mb-8' : ''
      } ${
        existingTag === undefined ||
        existingTag?.estateType === EstateType.Project
          ? 'lg:hidden'
          : ''
      }`}
      onClick={toggleExtraCriterias}
      type="button"
    >
      {filterText}
      <img
        width="20"
        height="20"
        id="extra-criterias-arrow"
        className="w-5 self-center transform ml-4"
        src={'/Images/Icons/Arrows/arrow-down-black500.svg'}
        alt="pil-ikon"
      />
    </button>
  );
};
export default ExtraFilterBtn;
